/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Session_LoadingInputs */



/**
* | output |
* | --- |
* | "Loading your practice conversation…" |
*
* @param {Practice_Session_LoadingInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_session_loading = /** @type {((inputs?: Practice_Session_LoadingInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Session_LoadingInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Je oefengesprek wordt geladen…")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Chargement de votre entretien d'entraînement…")
	return /** @type {LocalizedString} */ ("Loading your practice conversation…")
});